import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderChangeOtherExcludeGql } from '../bimWorkOrderChangeOthersQueries';

export const useExcludeWorkOrderChangeOtherPrice = ({
    workOrderChangeId,
    rowData,
    onSuccess,
}: {
    workOrderChangeId: number;
    rowData: {
        workOrderChangeOtherPriceId: number;
        workOrderOtherPriceId: number | null;
    }[];
    onSuccess: () => void;
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            workOrderChangeId,
            workOrderChangeOtherPriceId: {
                workOrderOtherPriceId: rowData?.[0]?.workOrderOtherPriceId,
                workOrderChangeOtherPriceId: rowData?.[0]?.workOrderChangeOtherPriceId,
            },
        }),
        [rowData, workOrderChangeId],
    );

    const [data, status, err, request, setData] = useRequest({
        requestId: 'bimWorkOrderChangeOtherPriceExclude',
        query: bimWorkOrderChangeOtherExcludeGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const handleExclude = useCallback(() => {
        dispatch(request(variables));
    }, [dispatch, request, variables]);

    return {
        excludeData: data,
        excludeStatus: status,
        excludeError: err,
        handleExclude,
        excludeSetData: setData,
    };
};
